export type TerritorialStatusKind =
  | "red"
  | "orange"
  | "green"
  | "blue"
  | "purple";

export const TERRITORIAL_STATUS_TEXTS: Record<TerritorialStatusKind, string> = {
  red: "радиус менее 4,5 км от других ДЦ",
  orange: "радиус от 4,5 до 5 км от других ДЦ",
  green: "радиус более 5 км от других ДЦ",
  blue: "радиус больше 4,5 км, но меньше 5 км от ДЦ своего холдинга",
  purple: "радиус меньше 4,5 км от ДЦ своего холдинга",
};

export const parseDistance = (
  value: string | number | null | undefined,
): number => {
  if (value == null || value === "") {
    return NaN;
  }
  return Number(value);
};

export const getTerritorialStatus = (
  distanceRaw: string | number | null | undefined,
  candidateType: string | null | undefined,
  isHolding: boolean | null | undefined = false,
): TerritorialStatusKind | null => {
  const distance = parseDistance(distanceRaw);
  if (Number.isNaN(distance)) {
    return null;
  }

  if (isHolding) {
    if (distance < 4.5) {
      return "purple";
    }
    if (distance < 5) {
      return "blue";
    }
    return "green";
  }

  if (distance < 4.5) {
    return "red";
  }
  if (distance < 5) {
    return "orange";
  }
  return "green";
};
